import React, { Fragment, useEffect, useState } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import TitleH4Component from "../../components/TitleH4Component";
import { Icon } from "@iconify/react/dist/iconify.js";
import stylebtn from "../../styles/btn.module.scss";
import { Link, useParams } from "react-router-dom";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import ParrafoComponent from "../../components/ParrafoComponent";
import LoaderComponent from "../../components/LoaderComponent";
import MoneyInputComponent from "../../components/MoneyInputComponent";
import {
  deleteAbonoVR,
  entregarPendientes,
  obtenerAbonos,
  obtenerDetalleventaR,
  postAbonoVR,
  putAbonoVR,
} from "../../api/ApiVenta";

import { useFormatter } from "../../hooks/useFormatter";
import { useEstadoFactura } from "../../hooks/useEstadoFactura";
import AlertComponent from "../../components/AlertComponent";
import InputComponent from "../../components/InputComponent";
import ModalAbono from "../../components/ModalAbono";
import { useAuth } from "../../context/AuthContext";
import ModalPendienteEntrega from "../../components/ModalPendienteEntrega";
import { postPendienteE } from "../../api/ProductoPendiente";
import { abrirPdfVentasRapidas } from "../../api/Pdf";
import BotonWhatsappPdfComponent from "../../components/BotonWhatsappPdfComponent";
import { compartirVentaRapidaWhatsApp } from "../../helpers/compartirDocumentoWhatsApp";

const DetalleVentaPage = () => {
  const { id } = useParams();
  const [showAbono, setABono] = useState(false);
  const { formatDate, formatDateUTC } = useFormatter();
  const { calcularEstadoFactura } = useEstadoFactura();
  const [loading, setLoading] = useState(false);
  const [currentFactura, setCurrentFactura] = useState([]);
  const [idFactura, setIdFactura] = useState("");
  const [data, setData] = useState([]);

  //const [estado, setEstado] = useState(2);
  const [currentEntrega, setCurrentEntrega] = useState([]);
  const [totalAbonos, setTotalAbono] = useState(0);
  const [totalElaboracion, setTotalElaboracion] = useState(0);

  const [pendienteEntrega, setPendienteEntrega] = useState(0);
  const [totalSubtotales, setTotalSubtotales] = useState(0);
  const [mensajealerta, setMensajealerta] = useState("");
  //Para la modal de registo de abono
  const [showRestroA, setRegistroA] = useState(false);
  const [showEntrega, setShowEntrega] = useState(false);
  const [abono, setAbono] = useState(0);
  const [entrega, setEntrega] = useState(0);
  const [mensaje, setMensaje] = useState("");
  const [alert, setAlert] = useState(false);
  const [hora_abono, setHora_abono] = useState(null);
  const [dataAbono, setDataAbono] = useState([]);
  const [showDetalle, setShowDetalle] = useState(false);
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  const [formDataPendiente, setFormDataPendiente] = useState({
    producto: "",
    fechaEntrega: "",
    horaEntrega: "",
  });
  const [descripcionAbono, setDescripcionAbono] = useState("");
  const [fecha_abono, setFecha_abono] = useState(null);
  //------------------------//
  //-Pendiente de entrega -//
  //------------------------//
  const [showRestroPE, setRegistroPE] = useState(false);
  const [dataPendienteE, setDataPendienteE] = useState([]);
  const handleShowRegistroP = () => {
    setRegistroPE(true);
  };
  const handleCloseRegistroPE = () => setRegistroPE(false);

  const { isAdmin, idUser, isSuper } = useAuth();
  const handleShowRegistroA = () => {
    setRegistroA(true);
  };

  const handleCloseAbono = () => {
    fetchFactura();
    setABono(false);
  };

  const handleChangeDescripcion = (event) => {
    setDescripcionAbono(event.target.value);
  };

  const handleInputChangePendientes = (e) => {
    setFormDataPendiente({
      ...formDataPendiente,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeFechaAbono = (event) => {
    setFecha_abono(event.target.value);
  };

  const handleChangeHoraAbono = (event) => {
    setHora_abono(event.target.value);
  };

  const handleShowDetalle = (item) => {
    setItemSeleccionado(item);
    setShowDetalle(true);
  };

  const handleCloseDetalle = () => {
    setShowDetalle(false);
    setItemSeleccionado(null);
  };

  useEffect(() => {
    if (!data) return;

    const { pendientes, subtotales } = data.reduce(
      (acc, item) => {
        acc.pendientes += Number(item?.pendiente_entrega) || 0;
        acc.subtotales += Number(item?.subtotal) || 0;
        return acc;
      },
      { pendientes: 0, subtotales: 0 },
    );

    setPendienteEntrega(pendientes);
    setTotalSubtotales(subtotales);
  }, [data]);

  const handleAbono = () => setABono(true);
  const handleClose = () => setABono(false);
  const handlentregaClose = () => setShowEntrega(false);

  const handleShowEntrega = (item) => {
    setCurrentEntrega(item);
    setEntrega(item?.pendiente_entrega);
    setShowEntrega(true);
    setMensaje("");
    setFormDataPendiente({
      producto: item?.producto,
    });
  };

  const handleCloseRegistroA = () => setRegistroA(false);

  const fetchFactura = async () => {
    setLoading(true);
    try {
      const factura = await obtenerDetalleventaR(id);
      setCurrentFactura(factura?.res?.data);
      setData(factura?.res?.data?.ventaRapidaDetalles);
      setIdFactura(factura?.res?.data?.id);
      // ✅ Procesar Abonos
      const formattedDataAbono =
        factura?.res?.data?.AbonoVentasRapidas?.map((item) => ({
          ...item,
          formattedDate: new Date(item?.createdAt).toLocaleDateString("es-ES"),
          formattedPrice: Number(item.monto).toLocaleString("es-ES"), // monto con separador
        }))?.sort((a, b) => new Date(a?.createdAt) - new Date(b?.createdAt)) ||
        [];
      setDataAbono(formattedDataAbono);

      // ✅ Calcular total de abonos
      const totalMontos =
        factura?.res?.data?.AbonoVentasRapidas?.reduce((total, item) => {
          return total + Number(item.monto || 0);
        }, 0) || 0;

      setTotalAbono(totalMontos);

      // ================================
      //  TRAER PENDIENTES ENTREGA
      // ================================
      const pendientes = factura?.res?.data?.PendientesEntregas || [];
      const pendientesOrdenados = [...pendientes].sort((a, b) => {
        const fechaA = `${a?.fechaEntrega || ""} ${a?.horaEntrega || "00:00:00"}`;
        const fechaB = `${b?.fechaEntrega || ""} ${b?.horaEntrega || "00:00:00"}`;

        return new Date(fechaB) - new Date(fechaA);
      });

      setDataPendienteE(pendientesOrdenados);

      // aquí podrías hacer la misma validación de tu otro fetchFactura con financiado vs abonos.
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchFactura();
    }
  }, [id, totalAbonos, totalElaboracion]);

  const handleInputChangeFactura = (event) => {
    setAbono(event.target.value);
  };

  const handleInputChangeentrega = (event) => {
    setEntrega(event.target.value);
  };

  //Crear abonos de ventas rapidas
  const crearAbonoVR = async () => {
    try {
      if (!abono || Number(abono) <= 0) {
        setMensaje("Cantidad incorrecta");
      } else {
        const { status, res } = await obtenerAbonos(idFactura, abono);
        if (status === 200) {
          await postAbonoVR(
            idFactura,
            abono,
            descripcionAbono,
            idUser,
            fecha_abono || null,
            hora_abono || null,
          );
          setAlert(true);
          setMensajealerta(res.msg);
          fetchFactura();
          handleCloseAbono();
          setAbono("");
          setDescripcionAbono("");
          setFecha_abono("");
          setHora_abono("");
        } else {
          setMensaje(res.msg ?? "Algo salio mal");
        }
      }
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setAlert(false);
      setMensaje("");
    }, 3000);
  };

  const entregarp = async () => {
    if (currentEntrega?.pendiente_entrega < entrega) {
      setMensaje(
        "La cantidad maxima que debe entregar: " +
        currentEntrega?.pendiente_entrega,
      );
    } else {
      const res = await entregarPendientes(
        currentEntrega?.id,
        currentEntrega?.id_ventaR,
        entrega,
      );

      if (res.status === 200) {
        const resp = await postPendienteE(
          id,
          formDataPendiente.producto,
          entrega,
          idUser,
          formDataPendiente.fechaEntrega,
          formDataPendiente.horaEntrega,
        );

        setAlert(true);
        setMensajealerta(res?.res?.msg);
        fetchFactura();
        handlentregaClose();
      }
    }

    setTimeout(() => {
      setAlert(false);
      setMensaje("");
    }, 3000);
  };

  //---------------------------------------//
  //----------Metodo de Abonos--------------//
  //---------------------------------------//
  const editarAbonoVR = async (
    obj,
    monto,
    descripcion,
    fecha_abono,
    hora_abono,
  ) => {
    try {
      const res = await putAbonoVR(
        obj?.id,
        monto,
        descripcion,
        fecha_abono,
        hora_abono,
      );
      if (res?.success) {
        setMensaje(res?.msg);
        fetchFactura();
      }
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setMensaje("");
    }, 3000);
  };

  //Eliminar abono
  const eliminarAbonoVR = async (obj) => {
    try {
      const res = await deleteAbonoVR(obj?.id);
      if (res?.success) {
        setMensaje(res?.msg);
        fetchFactura();
      }
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setMensaje("");
    }, 3000);
  };

  //---------------------------------------//
  //----------Retroceder--------------//
  //---------------------------------------//
  const handleGoBack = () => {
    //Retrocede una página en el historial
    window.history.back();
  };


  const generarPdf = async () => {
   await abrirPdfVentasRapidas(currentFactura?.id);
  }

  const estadoVentaInfo = calcularEstadoFactura({
    estado: currentFactura?.estado,
    fechaVencimiento: currentFactura?.fecha_vencimiento,
  });

  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <AlertComponent
          styleGroup="bg-soccess color-white"
          mensaje={mensajealerta}
          activaalert={alert}
        />
      </div>
      <HeaderComponent>
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          DETALLE DE{" "}
          {currentFactura?.tipo === "venta"
            ? "VENTA"
            : currentFactura?.tipo === "elaboracion"
              ? "ELABORACIÓN DE MADERA"
              : "COTIZACIÓN"}
        </TitleH2Component>
        {(currentFactura?.tipo === "cotizacion" ||
          ((currentFactura?.tipo === "venta") && currentFactura?.estado != 0) ||
          (currentFactura?.estado === 0)) && (
            <Link
              to={`/editar-factura/${currentFactura?.id}`}
              className={`${stylebtn.btn} ${stylebtn.primary}`}
            >
              EDITAR {currentFactura?.tipo === "venta" ? "FACTURA" : "COTIZACION"}
            </Link>
          )}
      </HeaderComponent>
      {loading ? (
        <LoaderComponent styleGroup="mt-5" />
      ) : (
        <div className="conatiner-global pt-3 mb-5">
          <section>
            <div className="container-fluid">
              <div className="row gy-4">
                <div className="col-12 col-md-6 col-xl-4">
                  <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                    {currentFactura?.nombre ||
                      currentFactura?.Cliente?.Persona?.nombre}{" "}
                    {currentFactura?.Cliente?.Persona?.apellido}
                  </TitleH2Component>
                  <TitleH4Component styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                    C.C:{" "}
                    {currentFactura?.cedula ||
                      currentFactura?.Cliente?.Persona?.cedula}
                  </TitleH4Component>

                  {currentFactura?.quien_recibe && (
                    <ParrafoComponent styleGroup="box-text fw700 roboto mb-1 text-center mt-3">
                      <span className="color-dark">Quien recibe:</span>{" "}
                      <span className="color-madera">
                        {currentFactura?.quien_recibe}
                      </span>
                    </ParrafoComponent>
                  )}

                  <ParrafoComponent styleGroup="box-text fw700 roboto mb-1 text-center mt-3">
                    <span className="color-dark me-2">Vendedor:</span>
                    <span className="color-madera">
                      {currentFactura?.User?.nombre || currentFactura?.vendedor}
                    </span>
                  </ParrafoComponent>
                </div>

                <div className="col-12 col-md-6 col-xl-4">
                  {(currentFactura?.tipo === "venta" || currentFactura?.tipo === "elaboracion") && (
                    <TitleH2Component
                      styleGroup={`${estadoVentaInfo.className} box-text color-dark fw700 roboto mb-1 text-center`}
                    >
                      {estadoVentaInfo.text}
                    </TitleH2Component>
                  )}
                </div>
                <div className="col-12 col-md-6 col-xl-4">
                  <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                    {currentFactura?.fecha_creacion
                      ? formatDateUTC(currentFactura?.fecha_creacion)
                      : formatDate(currentFactura?.createdAt)}
                  </TitleH2Component>
                </div>
              </div>
            </div>
          </section>
          <div className="d-flex justify-content-end m-3">
            <button
              type="button"
              onClick={handleGoBack}
              className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex color-dark`}
            >
              <Icon icon="icon-park-solid:back" />
            </button>
          </div>
          <section>
            <div className="d-flex justify-content-end flex-column align-items-end">
              <button
                onClick={handleAbono}
                className={`${stylebtn.btn_desnudo} ${stylebtn.icon} mb-3 p-0 d-inline-flex color-black`}
                disabled={
                  currentFactura?.estado === 0 || currentFactura?.estado === 2
                } // Deshabilita si el estado es 'Cerrada'
              >
                <Icon icon="solar:hand-money-linear" />
              </button>

              <button
                onClick={generarPdf}
                className={`${stylebtn.btn} ${stylebtn.primary}`}
              >
                GENERAR FACTURA
              </button>
              <BotonWhatsappPdfComponent
                onClick={() => compartirVentaRapidaWhatsApp(currentFactura)}
                disabled={!currentFactura?.id}
                styleGroup="mt-2"
              />
            </div>
          </section>

          {/** tabla de factura */}
          <section>
            <div className="table-responsive mt-4">
              <ParrafoComponent styleGroup=" color-dark fw400 WorkSans fw700">
                N° Factura: {currentFactura?.numeroFactura}
              </ParrafoComponent>

              {/* Tabla principal de productos */}
              <table className="table table-bordered tableGeneral">
                <thead>
                  <tr>
                    <th className="color-madera">Cant.</th>
                    <th className="color-madera">Descripcion</th>
                    {(currentFactura?.tipo === "venta" ||
                      currentFactura?.tipo === "elaboracion") && (
                        <th className="color-madera">Pend. Entrega</th>
                      )}
                    <th className="color-madera">Precio unidad</th>
                    <th className="color-madera">Sub Total</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <th>{item?.cantidad}</th>
                      <th>{item?.producto}</th>
                      {(currentFactura?.tipo === "venta" ||
                        currentFactura?.tipo === "elaboracion") && (
                          <th>
                            <p className="mb-0">{item?.pendiente_entrega}</p>
                            {item?.pendiente_entrega > 0 && (
                              <button
                                type="button"
                                className={`btn ${stylebtn.btn} ${stylebtn.primary}`}
                                onClick={() => handleShowEntrega(item)}
                              >
                                Entregar
                              </button>
                            )}
                          </th>
                        )}
                      <th>
                        $ {Number(item?.precioUnidad).toLocaleString("es-ES")}
                      </th>
                      <td>
                        ${" "}
                        {Number(
                          item?.subtotal ?? item?.elaboracionMadera,
                        ).toLocaleString("es-ES")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Tabla resumen separada, alineada a la derecha */}
              <div className="d-flex justify-content-end mt-0">
                <table
                  className="table table-bordered tableGeneral"
                  style={{ width: "auto", minWidth: "350px" }}
                >
                  <tbody>
                    <tr>
                      <td className="text-right fw600">SUBTOTAL</td>
                      <td>
                        $ {Number(totalSubtotales).toLocaleString("es-ES")}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right fw600">DESCUENTO</td>
                      <td>
                        ${" "}
                        {Number(currentFactura?.descuento).toLocaleString(
                          "es-ES",
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right fw600">TRANSPORTE</td>
                      <td>
                        ${" "}
                        {Number(currentFactura?.transporte).toLocaleString(
                          "es-ES",
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right fw600">PENDIENTE DE PAGO</td>
                      <td>
                        ${" "}
                        {currentFactura?.estado === 1
                          ? (
                            Number(currentFactura?.total ?? 0) +
                            Number(currentFactura?.transporte ?? 0) -
                            Number(currentFactura?.descuento ?? 0) -
                            Number(currentFactura?.total_pagado ?? 0)
                          ).toLocaleString("es-ES")
                          : 0}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right fw600">ABONO</td>
                      <td
                        onClick={handleShowRegistroA}
                        className="hover-pointer"
                      >
                        $ {Number(totalAbonos).toLocaleString("es-ES")}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right fw600">
                        PENDIENTE POR ENTREGA
                      </td>
                      <td
                        onClick={handleShowRegistroP}
                        className="hover-pointer"
                      >
                        # {pendienteEntrega}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right fw600">TOTAL CANCELADO</td>
                      <td
                        style={{
                          backgroundColor: "silver",
                          fontWeight: "bold",
                        }}
                      >
                        ${" "}
                        {Number(currentFactura?.total_pagado).toLocaleString(
                          "es-ES",
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right fw600">TOTAL</td>
                      <td
                        onClick={() => {
                          if (currentFactura?.tipo !== "elaboracion") {
                            handleShowDetalle(currentFactura);
                          }
                        }}
                        style={{
                          backgroundColor: "lightgreen",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                      >
                        ${" "}
                        {(
                          Number(currentFactura?.total ?? 0) +
                          Number(currentFactura?.transporte ?? 0) -
                          Number(currentFactura?.descuento ?? 0)
                        ).toLocaleString("es-ES")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          {/** Modal para abonar*/}
          <section>
            <ModalGeneralComponent
              styleGroup="d-flex align-items-center modal-general "
              styleTitle={
                "box-text color-madera fw700 roboto text-center WorkSans"
              }
              show={showAbono}
              handleClose={handleClose}
            >
              <div className="container">
                <form action="">
                  <div className="d-flex align-items-start justify-content-between">
                    <div>
                      <TitleH4Component styleGroup="box-text color-dark fw700 roboto mb-4 text-center">
                        {currentFactura?.Cliente?.Persona?.nombre}{" "}
                        {currentFactura?.Cliente?.Persona?.apellido}
                      </TitleH4Component>
                    </div>
                    <TitleH4Component styleGroup="mb-0 me-3">
                      {formatDate(currentFactura?.createdAt)}
                    </TitleH4Component>
                  </div>
                  <ParrafoComponent styleGroup="box-text color-danger fw700 roboto  text-center">
                    {mensaje}
                  </ParrafoComponent>

                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <MoneyInputComponent
                      label="PAGAR"
                      styleLabel="fw600 WorkSans"
                      //htmlFor="abono"
                      value={abono} // Asegúrate de pasar el valor correcto aquí
                      name="abono"
                      onChange={handleInputChangeFactura}
                      styleGroup="w-100"
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <textarea
                      label="descripcion"
                      name="descripcionAbono"
                      placeholder="Descripción"
                      className="form-control mt-3"
                      rows={3}
                      value={descripcionAbono}
                      onChange={handleChangeDescripcion}
                    ></textarea>
                  </div>
                  {isSuper && (
                    <div className="row">
                      <div className="col-12 col-md-6 col-xl-6">
                        <InputComponent
                          label="Fecha del abono"
                          styleLabel="fw600 WorkSans"
                          styleGroup="mb-3"
                          htmlFor="bloque"
                          type="date"
                          name="fecha_abono"
                          value={fecha_abono}
                          onChange={handleChangeFechaAbono}
                        />
                      </div>

                      <div className="col-12 col-md-6 col-xl-6">
                        <InputComponent
                          styleLabel="fw600 WorkSans"
                          htmlFor="bloque"
                          label="Hora del abono"
                          type="time"
                          value={hora_abono}
                          name="hora_abono"
                          onChange={handleChangeHoraAbono}
                        />
                      </div>
                    </div>
                  )}

                  <div className="d-flex w-100 justify-content-end aling-items-start">
                    <div className=" mt-4">
                      <button
                        type="button"
                        className={` ${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3 `}
                        onClick={handleClose}
                      >
                        CANCELAR
                      </button>
                      <button
                        onClick={crearAbonoVR}
                        type="button"
                        className={`btn ${stylebtn.btn} ${stylebtn.primary} `}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </ModalGeneralComponent>
          </section>

          {/** Modal producto pendiente de entrega*/}
          <section>
            <ModalGeneralComponent
              styleGroup="d-flex align-items-center modal-general "
              styleTitle={
                "box-text color-madera fw700 roboto text-center WorkSans"
              }
              show={showEntrega}
              handleClose={handlentregaClose}
            >
              <div className="container">
                <form action="">
                  <div className="d-flex align-items-start justify-content-between mb-3">
                    <TitleH4Component styleGroup="mb-0 me-3">
                      ENTREGAR
                    </TitleH4Component>
                    <TitleH4Component styleGroup="mb-0 me-3">
                      {formatDate(currentFactura?.createdAt)}
                    </TitleH4Component>
                  </div>
                  <ParrafoComponent styleGroup="box-text color-danger fw700 roboto  text-center">
                    {mensaje}
                  </ParrafoComponent>
                  <div className="row g-3">
                    <div className="col-12 col-sm-6">
                      <InputComponent
                        label="Cantidad"
                        styleLabel="fw600 WorkSans"
                        styleGroup="me-2"
                        htmlFor="bloque"
                        type="text"
                        name="entrega"
                        value={entrega}
                        onChange={handleInputChangeentrega}
                      />
                    </div>

                    <div className="col-12 col-sm-6">
                      <InputComponent
                        label="Producto"
                        styleLabel="fw600 WorkSans"
                        styleGroup="me-2"
                        htmlFor="bloque"
                        type="text"
                        name="producto"
                        value={formDataPendiente.producto}
                        onChange={handleInputChangePendientes}
                        disabled
                      />
                    </div>

                    <div className="col-12 col-sm-6">
                      <InputComponent
                        label="Fecha entrega"
                        styleLabel="fw600 WorkSans"
                        styleGroup="me-2"
                        htmlFor="bloque"
                        type="date"
                        name="fechaEntrega"
                        value={formDataPendiente.fechaEntrega}
                        onChange={handleInputChangePendientes}
                      />
                    </div>

                    <div className="col-12 col-sm-6">
                      <InputComponent
                        label="Hora entrega"
                        styleLabel="fw600 WorkSans"
                        styleGroup="me-2"
                        htmlFor="bloque"
                        type="time"
                        name="horaEntrega"
                        value={formDataPendiente.horaEntrega}
                        onChange={handleInputChangePendientes}
                      />
                    </div>
                  </div>

                  <div className="d-flex w-100 justify-content-end aling-items-start">
                    <div className=" mt-4">
                      <button
                        type="button"
                        className={` ${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3 `}
                        onClick={handlentregaClose}
                      >
                        CANCELAR
                      </button>
                      <button
                        onClick={entregarp}
                        type="button"
                        className={`btn ${stylebtn.btn} ${stylebtn.primary} `}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </ModalGeneralComponent>
          </section>
        </div>
      )}

      <ModalAbono
        mensaje={mensaje}
        show={showRestroA}
        handleClose={handleCloseRegistroA}
        data={dataAbono}
        currentFactura={currentFactura}
        editarAbono={editarAbonoVR}
        eliminarAbono={eliminarAbonoVR}
      />

      <ModalPendienteEntrega
        mensaje={mensaje}
        show={showRestroPE}
        handleClose={handleCloseRegistroPE}
        data={dataPendienteE}
        currentFactura={currentFactura}
      />

      {/** Modal ver pago total*/}
      <ModalGeneralComponent
        styleGroup="d-flex align-items-center modal-general"
        styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
        show={showDetalle}
        handleClose={handleCloseDetalle}
      >
        <div className="container p-3">
          {/* HEADER */}
          <div className="text-center mb-4">
            <TitleH4Component styleGroup="fw700">
              Detalle del pago
            </TitleH4Component>
          </div>

          {/* BODY */}
          <div className="card p-3 shadow-sm border-0 rounded-4">
            <div className="mb-3">
              <strong>Descripción:</strong>
              <p className="mb-0">
                {itemSeleccionado?.descripcionElaboracion || "Sin descripción"}
              </p>
            </div>
          </div>

          {/* FOOTER */}
          <div className="d-flex justify-content-end mt-4">
            <button
              className={`${stylebtn.btn_desnudo} ${stylebtn.line}`}
              onClick={handleCloseDetalle}
            >
              CERRAR
            </button>
          </div>
        </div>
      </ModalGeneralComponent>
    </Fragment>
  );
};

export default DetalleVentaPage;
